import { render, staticRenderFns } from "./BuildLesson.vue?vue&type=template&id=30616476&"
import script from "./BuildLesson.vue?vue&type=script&lang=js&"
export * from "./BuildLesson.vue?vue&type=script&lang=js&"
import style0 from "./BuildLesson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports